const parameterAliases = {
  quotationName: ['quotationName', 'quotation_name', 'name'],
  quotationNumber: ['quotationNumber', 'quotation_number', 'number'],
  custAccount: ['custAccount', 'customerAccount', 'customer', 'account', 'prospectId'],
  contactName: ['contactName', 'contact_name'],
  contactEmail: ['contactEmail', 'contact_email', 'email'],
  followUpDate: ['followUpDate', 'follow_up_date'],
  expiryDate: ['expiryDate', 'expiry_date'],
  opportunityId: ['opportunityId', 'opportunity_id', 'opportunity']
}

const getFirstParam = (params, names) => {
  for (const name of names) {
    const value = params.get(name)
    if (value) return value
  }

  return ''
}

const normalizeDate = (value) => {
  if (!value) return ''

  const isoDate = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/)?.slice(1)
  if (isoDate) {
    const [year, month, day] = isoDate
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
  }

  // Convert common European formats to the value expected by input[type=date].
  const europeanDate = value.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/)
  if (europeanDate) {
    const [, day, month, year] = europeanDate
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
  }

  return ''
}

export const getQuotationDataFromUrl = (search = window.location.search) => {
  const params = new URLSearchParams(search)
  const formData = {}

  Object.entries(parameterAliases).forEach(([field, aliases]) => {
    const value = getFirstParam(params, aliases)
    if (value) {
      formData[field] = field === 'followUpDate' || field === 'expiryDate'
        ? normalizeDate(value)
        : value
    }
  })

  // Only honour an explicit type hint. When the caller just passes a name/account we leave the
  // type undefined so CustomerOrProspectLookup resolves it against Dataverse (customer, existing
  // prospect, new prospect, or "choose one" when several match).
  const customerType = getFirstParam(params, ['customerType', 'customer_type', 'type']).toLowerCase()
  const isExistingCustomer = getFirstParam(params, ['isExistingCustomer', 'is_existing_customer']).toLowerCase()
  const hasProspectId = params.has('prospectId')

  if (customerType === 'customer' || isExistingCustomer === 'true') {
    formData.customerType = 'customer'
  } else if (customerType === 'prospect' || isExistingCustomer === 'false' || hasProspectId) {
    formData.customerType = 'prospect'
  }

  return formData
}

export const isQuotationCreateRequest = (search = window.location.search) => {
  const params = new URLSearchParams(search)

  // quotationNumber is also used by the embedded quotation list, so it is
  // not enough to identify the create form by itself.
  if (params.get('view') === 'create') return true

  return [
    'quotationName', 'quotation_name', 'name',
    'custAccount', 'customerAccount', 'customer', 'account', 'prospectId',
    'contactName', 'contact_name', 'contactEmail', 'contact_email', 'email',
    'followUpDate', 'follow_up_date', 'expiryDate', 'expiry_date',
    'opportunityId', 'opportunity_id'
  ].some(name => params.has(name))
}
